import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { FC, useState } from "react";
import GoodStar from "../../TDD-Images/good-star.png";
import BadStar from "../../TDD-Images/bad-star.png";
interface Props {
  options: { label: string;  parent:string; value: string; noOfStars: number }[];
  navigate?: (parent:string, value: string) => void;
}

const TrackQuestionDropDown: FC<Props> = ({ options, navigate }) => {
  const handleClick = (parent: string, value: string) => {
    if (navigate) navigate(parent, value);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="text-black shadow-none h-[54px] w-[148px]"
          size={"sm"}
        >
          Attempts
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[350px] p-1">
        {options.map((option, ind) => (
          <div className="flex gap-2" key={`${ind}`}>
            <Button
              key={option.label}
              variant="ghost"
              className="w-full text-black flex justify-center items-center gap-3"
              onClick={() => handleClick(option.parent, option.value)}
            >
              {option.label}
              <div className="flex justify-center items-center">
                <img
                  src={option.noOfStars >= 1 ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
                <img
                  src={option.noOfStars >= 2 ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
                <img
                  src={option.noOfStars >= 3 ? GoodStar : BadStar}
                  alt="star"
                  className="w-[27px] object-contain"
                />
              </div>
            </Button>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default TrackQuestionDropDown;
